/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SelectComponent from '../../../operations/shifts/SelectComponent';
import {
    fetchClientAddressListAsync,
    fetchClientAddressList,
    fetchClientData,
} from '../../../../actions/ClientData';
import { updateField } from '../../../../actions/BookingRequest';

const initialState = {
    id: null,
    reference_number: null,
    email: null,
    first_name: null,
    last_name: null,
    company_name: null,
    mobile: null,
    logo: null,
    legal_name: '',
    billing_email: null,
    billing_address_1: null,
    billing_address_2: null,
    billing_city: null,
    billing_postcode: null,
    default_admin_information: null,
    pay_by_banktransfer: false,
    average_score: null,
    category: null,
    last_booking_date: null,
    date_joined: null,
    total_past_bookings: null,
    total_future_bookings: null,
    default_freelancer_information: null,
};

class SelfManaged extends Component {
    handleUpdate = client => {
        if (client) {
            this.props.fetchClientAddressListAsync(client.id);
            this.props.fetchClientData(client);
        } else {
            this.props.fetchClientAddressList([]);
            this.props.fetchClientData(initialState);
        }
    };

    componentDidUpdate() {
        const { clientAddressList } = this.props;

        if (clientAddressList.length > 0) {
            const { address1, address2, city, postcode } = clientAddressList[0];
            this.props.updateField('address1', address1);
            this.props.updateField('address2', address2);
            this.props.updateField('city', city);
            this.props.updateField('postcode', postcode);
        } else {
            this.props.updateField('address1', null);
            this.props.updateField('address2', null);
            this.props.updateField('city', null);
            this.props.updateField('postcode', null);
        }
    }

    render() {
        const controlStyle = {
            borderStyle: 'none',
            marginBottom: '10px',
            boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.2)',
            height: '40px',
        };
        return (
            <SelectComponent
                onStyle={controlStyle}
                update={this.handleUpdate}
            />
        );
    }
}

export default connect(null, {
    fetchClientAddressListAsync,
    updateField,
    fetchClientAddressList,
    fetchClientData,
})(SelfManaged);
